module.exports = __webpack_public_path__ + "img/logo-red.c9f662b0.png";